import React, { ReactNode, useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { getIframeVisibleCenter } from '../helpers'

interface LicenseModalProps {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
  primaryLabel: string
  onPrimary: () => void
  primaryDisabled?: boolean
  cancelLabel?: string
}

function LicenseModal({
  open,
  onClose,
  title,
  children,
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  cancelLabel = 'Cancel',
}: LicenseModalProps) {
  const [center, setCenter] = useState(0)
  useEffect(() => {
    if (open) setCenter(getIframeVisibleCenter())
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      sx={{ '& .MuiDialog-container': { alignItems: 'flex-start' } }}
      PaperProps={{
        sx: {
          maxWidth: 420,
          marginTop: `${center}px`,
          transform: 'translateY(-50%)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        {title}
        <IconButton aria-label='Close' onClick={onClose} size='small'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
        <Button size='small' onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button
          variant='contained'
          size='small'
          disabled={primaryDisabled}
          onClick={onPrimary}
        >
          {primaryLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

LicenseModal.defaultProps = {
  primaryDisabled: false,
  cancelLabel: 'Cancel',
}

export default LicenseModal
